<template>
  <div>
    <div class="station-connected-domains-seperator mt-5 d-none d-md-block">
      <svg style="color: var(--primary-blue);" width="1140" height="36">
        <use href="#___icon___section-separator"></use>
      </svg>
    </div>
    <DomainInfo
      :data="data"
      :stationData="stationData"
      :descriptionText="descriptionText"
      :season="season"
      :content="content"
    />
    <ConnectedDomainInfo
      :data="data"
      :stationData="stationData"
      :season="season"
      :content="content"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import Collapsible from "@/collapsible/collapsible.js";
import DomainInfo from "./DomainInfo.vue";
import ConnectedDomainInfo from "./ConnectedDomainInfo.vue";

// Define types for the props
interface DomainsSection {
  data: Record<string, any>;
  stationData: Record<string, any>;
  descriptionText: string;
  season: string;
}

// Props
defineProps<DomainsSection>();

// Computed property for content
const content = computed<Record<string, string>>(() => {
  return window.content || {};
});

// Initialize collapsible elements
const initializeCollapsibleElements = () => {
  const collapsibles = document
    .querySelector("#station-wrapper")
    ?.querySelectorAll(".collapse");
  collapsibles &&
    Array.from(collapsibles).forEach((div) => {
      new Collapsible(div).init();
    });
};

// Lifecycle Hook
onMounted(() => {
  initializeCollapsibleElements();
});
</script>

<style scoped>
#connectedDomainDescription .MsoNoSpacing {
  display: inline;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
</style>
